export default __webpack_public_path__ + "static/wordpressLogo-8cd3a70b807850448ca68097cf2753a4.png";